import React from "react";

function ModelTimestampWithinHoursInput({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="modelTimestampWithinHoursInput" className="form-label">
        Model Timestamp Within Hours
      </label>
      <input
        type="text"
        className="form-control"
        id="modelTimestampWithinHoursInput"
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default ModelTimestampWithinHoursInput;
